<template>
  <div class="right-panel" :ddTimer="ddTimer">
    <ul class="item-list">
      <li class="current-time">
        <div class="circle">
          <div class="center-text">
            <p class="num" :class="time > ddTimer.estimatesTime ? 'bigNotice': ''">
              <img src="../../autoStudy/images/timeIcon.png" class="time-icon">
              <span class="timeArt">
                <span class="timePra">练习用时:</span>
                {{formatShowTime}}
              </span>
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
/* eslint-disable */

import { formatTime } from '@/utils';
import { mapGetters, mapActions } from 'vuex';
import { getUserLocalData } from '@/utils/auth';

let ddtimer = null;
export default {
  data() {
    return {
      showTime: 0,
      time: 0,
    };
  },
  components: {},
  props: {
    estimatesTime: Number,
    rightRate: Number,
    currentPointNum: Number,
    totalPointNum: Number,
    isCancelTimeoutNotice: false,
    ddTimer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(['qTime', 'module', 'showTimeoutNotice', 'component']),
    formatShowTime() {
      return formatTime(this.showTime);
    },
    formatTime() {
      return formatTime(this.ddTimer.estimatesTime);
    },
  },
  mounted() {
    this.renderCircle();
  },
  methods: {
    ...mapActions(['setQtime', 'setTimeoutNotice']),
    cancelTimeoutNotice() {
      this.setTimeoutNotice(false);
      this.$emit('cancelTimeoutNotice');
    },
    resetTimer() {
      this.setQtime(0);
      if (ddtimer) clearInterval(ddtimer);
    },
    pauseTimer() {
      this.setQtime(this.time);
      if (ddtimer) clearInterval(ddtimer);
    },
    renderCircle() {
      const questionUuid = this.component.source.questionInfo ? this.component.source.questionInfo.questionUuid : 1;
      if (sessionStorage.getItem('answerTime')) {
        this.time = Number(sessionStorage.getItem('answerTime').split('_')[1]);
      } else {
        const { spentTime } = getUserLocalData();
        this.time = spentTime;
      }

      if (ddtimer) clearInterval(ddtimer);
      ddtimer = setInterval(() => {
        ++this.time;
        sessionStorage.setItem('answerTime', `${questionUuid}_${this.time}`);
        this.showTime = this.time;
      }, 1000);
    },
    popGoOnAction() {
      this.setTimeoutNotice(false);
      this.$emit('cancelTimeoutNotice');
    },
  },
  destroyed() {
    this.pauseTimer();
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
*,
:after,
:before {
  box-sizing: border-box;
}
.right-panel {
  display: flex;
  justify-content: center;
  text-align: center;
  .item-text {
    margin-bottom: 5px;
    font-size: 12px;
    line-height: 12px;
    color: rgba(83, 198, 197, 1);
    text-align: center;
  }
  .circle {
    position: relative;
    font-size: 24px;
    line-height: 34px;
    color: rgba(17,31,44,.56);
    .center-text {
      color: #302D27;
      font-size: 16px;
      .time-icon{
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
      .timeArt{
        font-size: 16px !important;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        // color: #302D27;
        margin-left: 9px;
        color: #302D27;
        .timePra{
          color: #302D27;    
        }
      }
      .text {
        margin-bottom: 5px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(17,31,44,.56);
        text-align: center;
      }
      .num {
        font-size: 24px;
        line-height: 14px;
        color: rgba(17,31,44,.56);
        text-align: center;
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          margin-right: 10px;
          font-size: 24px;
          &.clock {
            animation: tada 2s linear;
          }
        }
      }
    }
  }
}

</style>
